import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';

const Background = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 10;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 10%;

	button {
		align-self: flex-end;
		margin-bottom: 10px;
		background: none;
		border: none;
		color: white;
		font-size: var(--fs-x-large);
		cursor: pointer;
		font-weight: bold;
	}
`;

const TextWrapper = styled.div`
	text-align: left;
	background-color: white;
	width: 100%;
	padding: 20px;
	max-height: 80%;
	overflow: scroll;
	white-space: pre-wrap;
	color: black;

	h1,
	h2,
	h3 {
		margin: 20px 0;
	}

	p {
		margin: 10px;
	}

	ul {
		margin-left: 30px;
	}
`;

class Modal extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false
		};
	}

	render() {
		const { children } = this.props;

		return (
			<Fragment>
				<div onClick={() => this.setState({ isOpen: true })}>{children}</div>
				{this.state.isOpen && (
					<Background
						isOpen={this.state.isOpen}
						onClick={() => this.setState({ isOpen: false })}
					>
						<button onClick={() => this.setState({ isOpen: false })}>X</button>
						<TextWrapper onClick={e => e.stopPropagation()}>
							<div dangerouslySetInnerHTML={{ __html: this.props.text }} />
						</TextWrapper>
					</Background>
				)}
			</Fragment>
		);
	}
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js